module.exports = __webpack_public_path__ + "static/media/santelys.e4ebea15.png";